// removed by extract-text-webpack-plugin
module.exports = {"collection":"_3EPinkGdJofuIOQX4FKYNr","header":"_2PEGQvkUZhuwhqRBRT15o6","title":"_1_WAN9qp6EGwchGVYvXdmd","activityTotal":"_3cHtNRKSfN5u9o9ipeyJ68","activitySort":"ROnlvyDIBPz0j1EcivqfG","collectionList":"_2Da4YK4mQMmOYl6dZOx5yD","lastItem":"CG2bSM1zWXj-qoAagGcy2"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AccountManagement/Collections.scss
// module id = 1081
// module chunks = 0